
import React from 'react';
import { Cat } from 'lucide-react';

interface TasksHeaderProps {
  dailyQuote: string;
}

export const TasksHeader = ({ dailyQuote }: TasksHeaderProps) => {
  return (
    <div className="text-center space-y-1 px-4">
      <h1 className="text-3xl md:text-4xl font-bold text-[#FEF7CD] flex items-center justify-center gap-2">
        Cat Task Master
        <Cat className="h-8 w-8 text-cat-primary animate-bounce" />
      </h1>
      <p className="text-[#8B5CF6] text-sm md:text-base">{dailyQuote}</p>
    </div>
  );
};
